/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Key_ColInputs */

const en_settings_apikeys_key_col = /** @type {(inputs: Settings_Apikeys_Key_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key`)
};

const zh_settings_apikeys_key_col = /** @type {(inputs: Settings_Apikeys_Key_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密钥`)
};

/**
* | output |
* | --- |
* | "Key" |
*
* @param {Settings_Apikeys_Key_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_key_col = /** @type {((inputs?: Settings_Apikeys_Key_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Key_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_key_col(inputs)
	return zh_settings_apikeys_key_col(inputs)
});
export { settings_apikeys_key_col as "settings.apikeys.key_col" }